(() => {
  const canonicalPages = new Map([
    ['/pages/down-in-rainelle', '/pages/down-in-rainelle-west-virginia'],
    ['/pages/down-in-hinton', '/pages/down-in-hinton-west-virginia'],
    ['/pages/the-free-state-of-mcdowell', '/pages/free-state-of-mcdowell-west-virginia'],
    ['/pages/tunnelton-vfd-west-virginia', '/pages/tunnelton-vfd'],
    ['/pages/55-county-sheriffs-project', '/pages/west-virginia-county-sheriffs-project']
  ]);

  const prepareMap = () => {
    const experienceRoot = document.querySelector('[data-mlx]');
    const alreadyRelocated = document.querySelector('[data-mlx-map-relocated] .mlx-map');
    const map = alreadyRelocated || experienceRoot?.querySelector('.mlx-map');
    if (!map) return;

    map.querySelectorAll('a[href]').forEach(link => {
      const raw = link.getAttribute('href');
      if (canonicalPages.has(raw)) link.setAttribute('href', canonicalPages.get(raw));
    });

    const canvas = map.querySelector('.mlx-map__canvas');
    if (canvas && !canvas.querySelector('.mlx-map__stage')) {
      const stage = document.createElement('div');
      stage.className = 'mlx-map__stage';
      const image = canvas.querySelector(':scope > img');
      const pins = [...canvas.querySelectorAll(':scope > .mlx-pin')];
      if (image) {
        image.setAttribute('width', '1280');
        image.setAttribute('height', '960');
        image.setAttribute('alt', 'West Virginia county map showing all 55 counties');
        stage.appendChild(image);
      }
      pins.forEach(pin => stage.appendChild(pin));
      canvas.appendChild(stage);
    }

    const roadmap = document.querySelector('.ml2-roadmap');
    if (roadmap && !document.querySelector('[data-mlx-map-relocated]')) {
      const shell = document.createElement('div');
      shell.className = 'mlx mlx-map-relocated';
      shell.setAttribute('data-mlx-map-relocated', '');
      roadmap.replaceWith(shell);
      shell.appendChild(map);
    }

    map.querySelectorAll('[data-mlx-story]').forEach(pin => {
      if (pin.dataset.mlxRelocateBound === 'true') return;
      pin.dataset.mlxRelocateBound = 'true';
      pin.addEventListener('click', () => {
        if (window.innerWidth >= 750) return;
        window.requestAnimationFrame(() => {
          map.querySelector('[data-mlx-map-panels]')?.scrollIntoView({behavior:'smooth', block:'nearest'});
        });
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', prepareMap, {once:true});
  } else {
    prepareMap();
  }

  document.addEventListener('shopify:section:load', prepareMap);
})();
